import {
  ApplicationCreate,
  ApplicationList,
  CustomerList,
  Home,
  ResetPassword,
} from "../pages";
import ApplicationEdit from "../pages/applications/ApplicationEdit";
import AddressEdit from "../pages/applications/addresses/AddressEdit";
import AddressEditCreate from "../pages/applications/addresses/AddressEditCreate";

import AddresList from "../pages/applications/addresses/AddressList";
import RelatedPersonCreate from "../pages/applications/contact/RelatedPersonCreate";

import RelatedPersonEditCreate from "../pages/applications/contact/RelatedPersonEditCreate";
import RelatedPersonIndividualEdit from "../pages/applications/contact/RelatedPersonIndividualEdit";
import RelatedPersonList from "../pages/applications/contact/RelatedPersonList";
import GeneralEdit from "../pages/applications/general/GeneralEdit";
import InvoiceGroupCreate from "../pages/invoiceGroups/InvoiceGroupCreate";
import ChangePassword from "../pages/auth/changePassword/ChangePassword";
import CustomerAddressDetail from "../pages/customers/CustomerAddressDetail";
import CustomerAddress from "../pages/customers/CustomerAddressList";
import CustomerEdit from "../pages/customers/CustomerEdit";
import CustomerGeneral from "../pages/customers/CustomerGeneral";
import CustomerRelatedPersonDetail from "../pages/customers/CustomerRelatedPersonDetail";
import CustomerRelatedPerson from "../pages/customers/CustomerRelatedPersonList";
import CustomerWorkOrderDetail from "../pages/customers/CustomerWorkOrderDetail";
import CustomerWorkOrderDetailDocument from "../pages/customers/CustomerWorkOrderDetailDocument";
import CustomerWorkOrderDetailGeneral from "../pages/customers/CustomerWorkOrderDetailGeneral";
import CustomerWorkOrder from "../pages/customers/CustomerWorkOrderList";
import InvoiceGroupList from "../pages/invoiceGroups/InvoiceGroupList";
import InvoiceGroupEdit from "../pages/invoiceGroups/InvoiceGroupEdit";
import CustomerInvoices from "../pages/customers/CustomerInvoices";
import CustomerProducts from "../pages/customers/CustomerProducts";
import CustomerDocumentList from "../pages/customers/CustomerDocumentList";
import CustomerDocumentUpload from "../pages/customers/CustomerDocumentUpload";

interface IRoute {
  path: string;
  name: string;
  label?: string;
  icon?: string;
  children?: any;
  component: any;
  props?: any;
}

const routes: IRoute[] = [
  {
    path: "/",
    name: "Home",
    label: "Home",
    component: Home,
  },
  {
    path: "/applications",
    name: "Basvurularim",
    label: "Basvurularim",
    component: ApplicationList,
  },
  {
    path: `applications/:id`,
    name: "Basvurularim",
    label: "Basvurularim",
    component: CustomerWorkOrderDetail,
  },
  {
    path: `applications/:id`,
    name: "Basvurularim",
    label: "Basvurularim",
    component: CustomerWorkOrderDetail,
    children: [
      {
        name: "İş Emri",
        label: "İş Emri",
        component: CustomerWorkOrderDetailGeneral,
        path: `general`,
      },
      {
        name: "İş Emri",
        label: "İş Emri",
        component: CustomerWorkOrderDetailDocument,
        path: `document`,
      },
    ],
  },

  {
    path: "/applications/create",
    name: "Basvurularim",
    label: "Basvurularim",
    component: ApplicationCreate,
  },
  {
    path: "/customers",
    name: "Müşteriler",
    label: "Müşteriler",
    component: CustomerList,
  },

  {
    path: "/customers/:customerId",
    name: "Müşteriler",
    label: "Müşteriler",
    component: CustomerEdit,
    children: [
      { component: CustomerGeneral, path: `customer_general` },
      {
        component: CustomerRelatedPerson,
        path: `customer_related_person`,
      },
      {
        component: CustomerRelatedPersonDetail,
        path: `customer_related_person/:contactId/detail`,
      },
      {
        component: CustomerAddress,
        path: `customer_address`,
      },
      {
        component: CustomerAddressDetail,
        path: `customer_address/:addressId/detail`,
      },
      {
        component: CustomerWorkOrder,
        path: `customer_workorders`,
      },
      {
        component: CustomerInvoices,
        path: `customer_invoices`,
      },
      {
        component: CustomerProducts,
        path: `customer_products`,
      },
      {
        component: CustomerDocumentList,
        path: `customer_documents`,
      },
      {
        component: CustomerDocumentUpload,
        path: `customer_documents/create`,
      },

      /*  {
        component: CustomerWorkOrderDetail,
        name: "İş Emri",
        label: "İş Emri",
        path: `customer_workorders/:id`,
      },
      {
        component: CustomerWorkOrderDetailGeneral,
        path: `customer_workorders/:id/general`,
      },
      {
        component: CustomerWorkOrderDetailDocument,
        path: `customer_workorders/:id/document`,
      }, */
    ],
  },
  {
    component: CustomerWorkOrderDetail,
    name: "İş Emri",
    label: "İş Emri",
    path: `customer_workorders/:id`,
    children: [
      {
        name: "İş Emri",
        label: "İş Emri",
        component: CustomerWorkOrderDetailGeneral,
        path: `general`,
      },
      {
        name: "İş Emri",
        label: "İş Emri",
        component: CustomerWorkOrderDetailDocument,
        path: `document`,
      },
    ],
  },

  /*  {
    path: "/invoice/invoice-group",
    name: "Basvurularim",
    label: "Basvurularim",
    component: InvoiceGroupList,
  },
  {
    path: "/invoice/invoice-group/create",
    name: "Basvurularim",
    label: "Basvurularim",
    component: InvoiceGroupCreate,
  },
  {
    path: "/invoice/invoice-group/:id",
    name: "Basvurularim",
    label: "Basvurularim",
    component: InvoiceGroupEdit,
  }, */
  {
    path: "/change-password",
    name: "Sifre",
    label: "Sifre",
    component: ChangePassword,
  },
  /*  {
    path: "/applications/:customerId",
    name: "Basvurularim",
    label: "Basvurularim",
    component: ApplicationEdit,
    children: [
      { component: GeneralEdit, path: `general` },
      {
        component: RelatedPersonList,
        path: `related_person`,
      },
      { component: AddressEdit, path: `address/:addressId/edit` },
      { component: AddressEditCreate, path: `address/create` },
      { component: RelatedPersonEditCreate, path: `related_person/create` },
      {
        component: RelatedPersonIndividualEdit,
        path: `related_person/:contactId/edit`,
      },
      {
        component: AddresList,
        path: `address`,
      },
    ],
  }, */
];

export default routes;
